module.exports = __webpack_public_path__ + "static/media/multi.6880bc15.svg";